import React, { useEffect } from 'react';
import { cookies } from '../../CookiesHandler/cookies';
import { Button, Flex } from '@chakra-ui/react';
import { useTranslation, Trans } from 'react-i18next';

import './Styles/Consent.css'

const Consent = (props) => {

    const { t } = useTranslation( );

    const [policyAccepted, setPolicyAccepted] = React.useState(false);

    useEffect( () => {
        setPolicyAccepted( cookies.get('policy') );
    }, []);

    const policyConsent = (  
        <section id="cookies-policy">
            <Flex direction="column">
                <Flex w="100%" direction="row" justifyContent="space-between" alignItems="flex-start">
                    <p>
                        <Trans components={{ Anchor: <a href="https://feedinapp.com/privacy.html"/>}} >
                            policyMessage
                        </Trans>
                    </p>
                    <div>
                        <button className="exit" onClick={() => { policyAcceptedHandler() }}>
                            <svg width="19" height="19" viewBox="0 0 19 19">
                                <path d="M13.8 4.6L9.5 8.89 5.21 4.6l-.61.61 4.29 4.3-4.29 4.28.61.62 4.3-4.3 4.28 4.3.62-.62-4.3-4.29 4.3-4.29" fillRule="evenodd"></path>
                            </svg>
                        </button>
                    </div>
                </Flex>
                
                <Button onClick={() => { policyAcceptedHandler() }} size="xl" h="48px" w="100%"
                        variant="outline" ml="0" mr="0" colorScheme="green" mt="2">
                    { t("acceptButton") }
                </Button>
            </Flex>
        </section>
    );

    /**
     * Se non è ancora stato dato il consenso e viene cliccato il pulsante 
     * imposta un nuovo cookie della durata di 30gg
     */
    const policyAcceptedHandler = () => {

        if( !policyAccepted ) {
            cookies.set('policy', '1', {path: '/', expires: new Date(Date.now()+2592000)}) 
            setPolicyAccepted(true);
        }
    }

    return ( !policyAccepted ? policyConsent : null );
}

export default Consent;